// extracted by mini-css-extract-plugin
export var quillEditor = "_k6-1";
export var variable = "_k6-0";